import { showErrorAlert, showSuccessAlert } from 'actions';
import {
  fetchCustomerContacts,
  fetchCustomerContactsFailure,
  fetchCustomerContactsRequest,
  fetchCustomerContactsSuccess,
  upsertCustomerContacts,
  upsertCustomerContactsFailure,
  upsertCustomerContactsRequest,
  upsertCustomerContactsuccess,
} from 'actions/customerContacts';
import { apiClient as LitLingoClient } from 'client';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API, SagaReturn } from 'types';

function* fetchCustomerContactsSaga(): SagaReturn {
  yield put(fetchCustomerContactsRequest());

  const response = (yield call([
    LitLingoClient.resources.customerContacts.extras,
    'current',
  ])) as API.Response<API.CustomerContacts.Retrieve>;

  if (response.error != null) {
    yield put(fetchCustomerContactsFailure(response.error));
  } else {
    yield put(fetchCustomerContactsSuccess(response.data));
  }
}

function* upsertCustomerContactsaga(action: ReturnType<typeof upsertCustomerContacts>): SagaReturn {
  const { payload } = action;

  yield put(upsertCustomerContactsRequest());

  const response = (yield call([LitLingoClient.resources.customerContacts, 'upsert'], {
    data: payload,
  })) as API.Response<API.CustomerContacts.Upsert>;

  if (response.error != null) {
    yield put(upsertCustomerContactsFailure(response.error));

    yield put(
      showErrorAlert(
        "Something went wrong and the contacts information can't be saved at this time"
      )
    );
  } else {
    yield put(upsertCustomerContactsuccess(response.data));
    yield put(showSuccessAlert(`Contacts information has been saved successfully`));
  }
}

function* customerContactsSaga(): SagaReturn {
  yield takeLatest(fetchCustomerContacts.toString(), fetchCustomerContactsSaga);
  yield takeLatest(upsertCustomerContacts.toString(), upsertCustomerContactsaga);
}

export default customerContactsSaga;
